import { UrlMappingEndpoints } from '../types/types';

export const createUrl = (
  apiPrefix: string,
  endpoint: Partial<UrlMappingEndpoints>,
  isServer = false,
  dynamicPathFragments?: Record<string, string | number | undefined>,
  removeTrailingSlash = true
) => {
  const url = `${apiPrefix}${getEndpoint(endpoint as UrlMappingEndpoints, isServer)}`;

  if (dynamicPathFragments) {
    return Object.keys(dynamicPathFragments).reduce((acc, key) => {
      return acc.replace(`{${key}}`, dynamicPathFragments[key]?.toString() ?? '');
    }, url);
  }

  if (removeTrailingSlash) {
    return url.endsWith('/') ? url.slice(0, -1) : url;
  }

  return url;
};

export const getEndpoint = <C extends string, S extends string>(
  endpoint: UrlMappingEndpoints<S, C>,
  isServer = false
) => (isServer ? endpoint.server : endpoint.client);
